import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';
import MarkerSelected from '../../assets/img/map_marker_orange.png';

const DG = require('2gis-maps');

class RegistryMap extends React.Component {
    constructor(props) {
        super(props);

        this.map = null;
        this.markers = null;
        this.activeMarkerIcon = null;

        this.drawMarkers = this.drawMarkers.bind(this);
    }

    drawMarkers() {
        if (this.props.markers) {
            
            this.markers.removeFrom(this.map);
            this.markers.clearLayers();

            this.props.markers.forEach(nowMarker => {
                if (nowMarker.id == this.props.selectedId) {
                    DG.marker(
                        nowMarker.coordinates, {
                        title: nowMarker.title,
                        icon: this.activeMarkerIcon
                    })
                    .addTo(this.markers);
                }
                else {
                    DG.marker(
                        nowMarker.coordinates, {
                        title: nowMarker.title
                    })
                    .addTo(this.markers);
                }       
            });

            this.markers.addTo(this.map);
            // this.map.fitBounds(this.markers.getBounds());
        }
    }

    componentDidMount() {
        this.map = DG.map('2gis-map', this.props.mapSettings);
        this.markers = DG.featureGroup();
        this.activeMarkerIcon = DG.icon({
            iconUrl: MarkerSelected,
            
        });

        this.drawMarkers();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.updateInd !== this.props.updateInd) {
            this.drawMarkers();
        }
    }

    render() {
        return (
            <div id="2gis-map" className="registry-map-container">
            </div>
        );
    }
}

export default RegistryMap;